import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress, TableRow, TableCell, TableBody, Table, TableHead, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import DataTable from "../components/DataTable";
import { webEndPoint } from "../constants/globalConstants";
import { makeRequest } from "../services/api";
import EditIcon from "@mui/icons-material/Edit";
export default function Purchase() {
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [sizeCategoryData, setSizeCategoryData] = useState([]);
    const [colorData, setColorData] = useState([]);
    const [supplierData, setSupplierData] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState("");
    useEffect(() => {
        fetchProductdata();
        fetchMasterData();
    }, []);
    const inputStyle = {
        minWidth: 140,
        height: 40,
        "& .MuiInputBase-root": {
            height: 40
        }
    };
    const fetchProductdata = async () => {
        setLoading(true);
        try {
            const res = await makeRequest("get", webEndPoint + "product");
            if (res) setDataSource(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchMasterData = async () => {
        setLoading(true);
        const apis = {
            sizes: setSizeCategoryData,
            colors: setColorData,
            supplier: setSupplierData
        };
        try {
            const keys = Object.keys(apis);
            const responses = await Promise.all(
                keys.map((key) => makeRequest("get", webEndPoint + key))
            );
            responses.forEach((res, index) => {
                if (res) {
                    apis[keys[index]](res.data);
                }
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openEdit = (product) => {
        setSelectedProduct(product);
        setStockData(
            product?.stock?.length
                ? product.stock
                : [
                    {
                        size_id: "",
                        color_id: "",
                        retail_quantity: 0,
                        wholesale_quantity: 0
                    }
                ]
        );
        setSelectedSupplier("");
        setOpen(true);
    };
    const handleStockChange = (index, field, value) => {
        const updated = [...stockData];
        updated[index][field] = value;
        setStockData(updated);
    };
    const addStockRow = () => {
        setStockData((prev) => [
            ...prev,
            {
                size_id: "",
                color_id: "",
                retail_quantity: 0,
                wholesale_quantity: 0
            }
        ]);
    };
    const handleStockSave = async () => {
        try {
            setLoading(true);
            const requests = stockData.map((item) => {
                const payload = {
                    product_id: selectedProduct?.rfId,
                    supplier_id: selectedSupplier,
                    color_id: item.color_id,
                    size_id: item.size_id,
                    digital_quantity: item.retail_quantity,
                    wholesale_quantity: item.wholesale_quantity
                };
                return makeRequest("post", webEndPoint + "product-stock", payload);
            });
            const res = await Promise.all(requests);
            if (res) {
                setOpen(false);
                fetchProductdata();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = dataSource?.filter((d) =>
        d?.product_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Main Category", "Sub Category", "Product Name", "Action"];
    const rows = filteredState?.map((p, i) => [
        i + 1,
        p.maincategory_name,
        p.subcategory_name,
        p.product_name,
        <Tooltip title="Edit" key={i}>
            <IconButton onClick={() => openEdit(p)} color="primary">
                <EditIcon />
            </IconButton>
        </Tooltip>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Product" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>Update Stock - {selectedProduct?.product_name}</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ mb: 2 }}>
                        <TextField select fullWidth label="Select Supplier" value={selectedSupplier} onChange={(e) => setSelectedSupplier(e.target.value)} sx={inputStyle}>
                            {supplierData.map((s) => (
                                <MenuItem key={s.rfId} value={s.rfId}>
                                    {s.supplier_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>
                    <Button variant="outlined" onClick={addStockRow} sx={{ mb: 2 }}>+ Add Row</Button>
                    <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Size</TableCell>
                                <TableCell>Color</TableCell>
                                <TableCell>Retail</TableCell>
                                <TableCell>Wholesale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stockData.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <TextField select fullWidth value={item.size_id || ""} onChange={(e) => handleStockChange(index, "size_id", e.target.value)} sx={inputStyle}>
                                            {sizeCategoryData.map((s) => (
                                                <MenuItem key={s.rfId} value={s.rfId}>
                                                    {s.size_name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField select fullWidth value={item.color_id || ""} onChange={(e) => handleStockChange(index, "color_id", e.target.value)} sx={inputStyle}>
                                            {colorData.map((c) => (
                                                <MenuItem key={c.rfId} value={c.rfId}>
                                                    {c.color_name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField type="number" value={item.retail_quantity || 0} onChange={(e) => handleStockChange(index, "retail_quantity", Number(e.target.value))} sx={inputStyle} inputProps={{ style: { textAlign: "center" } }} />
                                    </TableCell>
                                    <TableCell>
                                        <TextField type="number" value={item.wholesale_quantity || 0} onChange={(e) => handleStockChange(index, "wholesale_quantity", Number(e.target.value))} sx={inputStyle} inputProps={{ style: { textAlign: "center" } }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleStockSave}> Save Stock</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}